<template>
  <div class="print-d" style="margin:auto;" v-loading="loading">
    <div class="content">
      <div class="left">
        <div class="title">
          汕头市金山中学
          <br/>
          {{year}}年自主招生考试
        </div>
        <div class="name">准考证</div>
        <div class="info">
          <div class="item" style="width:100%;">
            <div class="label">准考证号：</div>{{data.AdmissionNo}}
          </div>
          <div class="item" style="width: 45%;">
            <div class="label">姓名：</div>{{data.FullName}}
          </div>
          <div class="item">
            <div class="label">性别：</div>{{data.Sex==1?"男":"女"}}
          </div>
          <div class="item" style="width:100%;">
            <div class="label">身份证号：</div>{{data.IdCard}}
          </div>
        </div>
        <div class="photo">
          <el-image v-if="!loading" :src="'/api'+data.PicUrl" fit="cover" :preview-src-list="['/api'+data.PicUrl]" />
          <div class="photo-box">
            此处<br/>加贴<br/>近期<br/>彩照
          </div>
        </div>
        <div class="address">
          考场地点：汕头市金山中学
          <br/>
          （汕头市礐石风景区塔山景区对面）
        </div>
      </div>
      <div class="right">
        <div class="right-top">
          <div class="time-title">测试时间表</div>
          <div class="time">（日期：{{data.Date}}）</div>
          <table border="1" class="table">
            <tr>
              <td class="td-title">午别</td>
              <td class="td-title">时间</td>
              <td class="td-title" style="letter-spacing:0;">核心素养考核项目</td>
            </tr>
            <tr v-for="(item,index) in data.Sessions" :key="index">
              <td>{{item.Noon}}</td>
              <td>{{item.Time}}</td>
              <td>{{item.Subject}}</td>
            </tr>
          </table>
        </div>
        <div class="tip">
          <div class="tip-title">注意事项：</div>
          <div class="tip-content">
            <span style="white-space: pre-line" v-html="data.Note"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="handle-button no-print">
      <el-button icon="el-icon-printer" size="mini" type="primary" @click="print">打印</el-button>
    </div>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();

export default {
  beforeMount() {
    this.loading = true;
    var id = this.$route.query.id;
    this.api.getAdmissionTicket(id).then(res => {
      this.loading = false;
      if(res.Code==0) {
        this.data = res.Data;
        if(res.Data.Note) this.data.Note = res.Data.Note.replaceAll(" ","&ensp;");
        // this.data.Sessions = [{ Noon: "下午", Time: "13:15 - 15:00", Subject: "语文、物理" }];
      } else this.$message.error(res.Msg);
    });
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      data: {
        AdmissionNo: "",
        Date: "",
        FullName: "",
        IdCard: "",
        Note: "",
        PicUrl: "",
        Sessions: [],
        Sex: null
      },
      loading: false,
      year,
    };
  },
  methods: {
    print() {
      window.print();
    },
  }
};
</script>
<style lang="scss" scoped>
.print-d {
  width: 900px;
  padding: 10px 0;
}
.handle-button {
  position: fixed;
  top: 10px;
  right: 30px;
}
.content {
  font-family: "宋体","微软雅黑";
  width: 100%;
  border: 1px solid #000;
  font-size: 16px;
  display: flex;
  * {
    box-sizing: border-box;
  }
  .left {
    width: 50%;
    // border-right: 1px #aaa dashed;
    //------------------------------
    .title {
      text-align: center;
      letter-spacing: 1px;
      font-size: 20px;
      margin: 20px 0 10px;
      line-height: 30px;
    }
    //------------------------------
    .name {
      font-size: 28px;
      letter-spacing: 5px;
      margin: 10px 0;
      text-align: center;
      padding-bottom: 15px;
      // border-bottom: 1px #aaa dashed;
    }
    //------------------------------
    .number {
      padding: 12px 12px 16px 0;
      // border-bottom: 1px #aaa dashed;
      .label {
        text-align: right;
        width: 100px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    //------------------------------
    .info {
      padding: 10px 0;
      display: flex;
      flex-wrap: wrap;
      .item {
        display: inline-block;
        line-height: 45px;
        .label {
          text-align: right;
          width: 100px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }
    //------------------------------
    .photo {
      width: 100%;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-evenly;
      // border-bottom: 1px #aaa dashed;
      .el-image,.photo-box {
        height: 165px;
        width: 130px;
      }
      .photo-box {
        border: 1px solid #000;
        text-align: center;
        font-size: 20px;
        padding-top: 8%;
        letter-spacing: 2px;
      }
    }
    //------------------------------
    .address {
      padding: 10px 0 10px 20px;
      line-height: 30px;
    }
  }
  .right {
    width: 50%;
    .right-top {
      // border-bottom: 1px #aaa dashed;
      //-------------------------
      .time-title {
        padding: 40px 0 10px;
        font-size: 20px;
        letter-spacing: 1px;
        text-align: center;
      }
      //-------------------------
      .time {
        text-align: center;
      }
      //-------------------------
      .table {
        margin: 10px auto 20px;
        width: 320px;
        border-spacing: 0;
        border-collapse: collapse;
        td {
          border-width: 2px;
          text-align: center;
          height: 40px;
        }
        .td-title {
          height: 30px;
          letter-spacing: 5px;
        }
      }
    }
    //------------------------
    .tip {
      padding: 20px 20px 0;
      .tip-title {
        margin-bottom: 15px;
      }
      .tip-content {
        line-height: 22px;
        margin-bottom: 8px;
      }
    }
  }
}
@media print {
  .print-d {
    width: 100%;
    padding: 0;
  }
  .no-print {
    display: none;
  }
}
</style>